module.exports = __webpack_public_path__ + "static/media/Death Prophet.67a0f765.png";